


import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";

const GatewayHistory = ({userMobile}) => {
  const [transactions, setTransactions] = useState([]);
  const [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const [searchList, setSearchList] = useState("");
  const [searchType, setSearchType] = useState("");
  const [findByStatus, setFindByStatus] = useState("");

  const backendLocal = process.env.REACT_APP_BACKEND_LOCAL_API;
  const backendLive = process.env.REACT_APP_BACKEND_LIVE_API;
  const baseUrl =
    process.env.NODE_ENV === "development" ? backendLocal : backendLive;

  const access_token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${access_token}`,
  };

  // ✅ Fetch transactions
 
  // const fetchTransactions = async () => {
  //   try {
  //     const res = await axios.get(
  //       `${baseUrl}txn/gateway/history?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}`,
  //       { headers }
  //     );

  //     setTransactions(res?.data?.transactions || []);
  //     setNumberOfPages(res?.data?.totalPages || 0);
  //   } catch (e) {
  //     if (e.response?.status === 401) {
  //       localStorage.removeItem("token");
  //       window.location.reload();
  //     }
  //   }
  // };
  const fetchTransactions = async () => {
  try {
    const res = await axios.get(
      `${baseUrl}txn/gateway/history?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}`,
      { headers }
    );

    setTransactions(res?.data?.transactions || []);
    setNumberOfPages(res?.data?.totalPages || 0);
  } catch (e) {
    if (e.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.reload();
    }
  }
};



  // ✅ Pagination handler
  const handlePageClick = (data) => {
    const currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  useEffect(() => {
    setPageNumber(1);
  }, [limit, searchList, searchType, findByStatus]);

  useEffect(() => {
    fetchTransactions();
  }, [pageNumber, limit, searchList, searchType, findByStatus]);

  const dateFormat = (e) => {
    const date = new Date(e);
    return date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  return (
    <div className="other_page_cards_main">
      <div className="row">
        <div className="col-12 grid-margin">
          <h4 className="other_page_cards_heading">Deposit Gateway History</h4>

          {/* 🔍 Filters */}
          <div className="row">
            <select
              className="form-control col-sm-3 m-2"
              onChange={(e) => setSearchType(e.target.value)}
            >
              <option value="">Select Search by</option>
              <option value="Name">Name</option>
              <option value="Phone">Phone</option>
              <option value="_id">TxnId</option>
            </select>

            <input
              type="text"
              placeholder="Search..."
              className="form-control col-sm-4 m-2"
              onChange={(e) => setSearchList(e.target.value)}
            />

            <h5>Or</h5>

           

            <select
              className="form-control col-sm-1 m-1 bg-dark text-light"
              onChange={(e) => setLimit(Number(e.target.value))}
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
          </div>

          {/* 🧾 Table */}
          <div className="table-responsive mt-3">
            <table className="table other_page_table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ID</th>
                  <th>Phone</th>
                  <th>User</th>
                  <th>ReferenceId/UTR</th>
                  <th>Amount</th>
                  <th>Image</th>
                  <th>Status</th>
                  <th>Gateway</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {transactions?.length > 0 ? (
                  transactions.map((data, index) => (
                    <tr key={data._id}>
                      <td>{index + 1}</td>
                      <td>{data._id}</td>
                    <td>
  {data?.User_id?.Phone
    ? userMobile
      ? data.User_id.Phone
      : `${data.User_id.Phone.toString().slice(0, 2)}****${data.User_id.Phone
          .toString()
          .slice(-2)}`
    : '-'}
</td>
                      <td>
                        {data.User_id ? (
                          <Link
                            className="btn btn-sm btn-outline-info"
                            to={`/user/view_user/${data.User_id._id}`}
                          >
                            {data.User_id.Name}
                          </Link>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>{data.referenceId}</td>
                      <td>{data.amount}</td>
                      <td>
                        {data.paymentImage ? (
                          <a
                            href={`${baseUrl}${data.paymentImage}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              alt=""
                              src={`${baseUrl}${data.paymentImage}`}
                              onError={(e) => {
                                e.target.src =
                                  "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg";
                              }}
                              height={60}
                            />
                          </a>
                        ) : (
                          <img
                            alt=""
                            src="https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                            height={60}
                          />
                        )}
                      </td>
                      <td
                        className={
                          data.status === "SUCCESS"
                            ? "text-success"
                            : data.status === "failed"
                              ? "text-danger"
                              : "text-warning"
                        }
                      >
                        {data.status.toUpperCase()}
                      </td>
                      <td>{data.payment_gatway}</td>
                      <td>{dateFormat(data.createdAt)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center text-muted">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* 🔢 Pagination */}
          <div className="mt-4">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={numberOfPages}
              forcePage={pageNumber - 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GatewayHistory;
